module.exports = __webpack_public_path__ + "static/media/top-right-background-effect.27914496.png";